import { iTask } from "@sdk/tasks/task-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";
import find from "lodash/find";

export const {
  selectQueryMap: selectTaskQueryMap,
  selectEntityMap: selectTasksMap,
  selectQueryMapAll: selectTasksMapAll,
  selectQueryAllList: selectTasksAllList,
  selectAllEntities: selectAllTasks,
  selectAllEntitiesQuery: selectAllTasksQuery,
  selectEntityById: selectTaskById,
  selectEntityQuery: selectTaskQuery,
  selectEntityQueryList: selectTaskQueryList
} = CreateSelectorForEntities<iStore, iTask>({
  sliceName: "tasks"
});

export const selectTaskByConnectionId = (connectionId: string) => (
  state: iStore
) => {
  return find(selectAllTasks(state), {
    connectionId
  });
};
